import { PackagingSystemDto } from '../packaging-system-entities/packaging-system-dto';
import { PackagingUnitDto } from '../packaging-unit-entities/packaging-unit-dto';
import { EvaluationResultDto } from './evaluation-result-dto';
import { PackagingSystemEntryDto, PackagingUnitEntryDto } from './packaging-part-results/packaging-system-recyclability-result-dto';

export class ExpenseResultsDto<T extends ExpenseResultDto> extends EvaluationResultDto {
  evaluationCountry: string;
  private _licenseFee?: T;
  private _ecomodulation?: T;
  private _plasticTax?: T;

  constructor (evaluationCountry: string) {
    super();
    this.evaluationCountry = evaluationCountry;
  }

  get licenseFee(): T | undefined {
    return this._licenseFee;
  }
  get ecomodulation(): T | undefined {
    return this._ecomodulation;
  }
  get plasticTax(): T | undefined {
    return this._plasticTax;
  }

  private setBaseValues(result: T) {
    this.id = result.id;
    this.creationTimestamp = result.creationTimestamp;
    this.lastAccessTimestamp = result.lastAccessTimestamp;
    this.evaluatedCountry = result.evaluatedCountry;
    this.evaluationReferenceTimestamp = result.evaluationReferenceTimestamp;
  }

  set licenseFee(licenseFee: T) {
    this._licenseFee = licenseFee;
    this.setBaseValues(licenseFee);
  }
  set ecomodulation(ecomodulation: T) {
    this._ecomodulation = ecomodulation;
    this.setBaseValues(ecomodulation);
  }
  set plasticTax(plasticTax: T) {
    this._plasticTax = plasticTax;
    this.setBaseValues(plasticTax);
  }
}

export class PackagingSystemExpenseResultsDto extends ExpenseResultsDto<PackagingSystemExpenseResultDto> {
  analyzedPackagingSystem!: PackagingSystemDto;
  packagingUnitResults: PackagingUnitEntryExpenseResultsDto[];
  packagingSystemResults: PackagingSystemEntryExpenseResultsDto[];

  constructor(evaluationCountry: string) {
    super(evaluationCountry);
    this.packagingUnitResults = [];
    this.packagingSystemResults = [];
  }
}

export class PackagingUnitExpenseResultsDto extends ExpenseResultsDto<PackagingUnitExpenseResultDto> {
  analyzedPackagingUnit!: PackagingUnitDto;

  constructor(evaluationCountry: string) {
    super(evaluationCountry);
  }
}

export class ExpenseResultDto extends EvaluationResultDto {
  expense!: Expense | null;
}

export class Expense {
  amount!: number;
  currency!: Currency;
  informationSource?: string;
}

export class Currency {
  symbol!: string;
  name!: string;
}

export class PackagingUnitExpenseResultDto extends ExpenseResultDto {
  analyzedPackagingUnit!: PackagingUnitDto;
}

export class PackagingSystemExpenseResultDto extends ExpenseResultDto {
  analyzedPackagingSystem!: PackagingSystemDto;
  packagingSystemResults!: PackagingSystemEntryExpenseResultDto[];
  packagingUnitResults!: PackagingUnitEntryExpenseResultDto[];
}

export class PackagingSystemEntryExpenseResultDto extends ExpenseResultDto {
  analyzedPackagingSystemEntry!: PackagingSystemEntryDto;
  packagingSystemResult!: PackagingSystemExpenseResultDto;
}

export class PackagingUnitEntryExpenseResultDto extends ExpenseResultDto {
  analyzedPackagingUnitEntry!: PackagingUnitEntryDto;
  packagingUnitResult!: PackagingUnitExpenseResultDto;
}

export class PackagingSystemEntryExpenseResultsDto {
  analyzedPackagingSystemEntry!: PackagingSystemEntryDto;
  packagingSystemResult!: PackagingSystemExpenseResultsDto;
}

export class PackagingUnitEntryExpenseResultsDto {
  analyzedPackagingUnitEntry!: PackagingUnitEntryDto;
  packagingUnitResult!: PackagingUnitExpenseResultsDto;
}
